import { DrxBannerConfig } from "./types";

// NB: You can provide dates in any timezone
// NB: the dates are used to determine whether or not
// the banner will be shown - see isBannerActive
// Banner will be shown if startDate <= today <= endDate
export const BannerConfig: DrxBannerConfig = {
  data: {
    text: `Royal Mail strikes may affect your delivery. 
    <a href="https://support.medexpress.co.uk/hc/en-gb/articles/7010990310045-Planned-Royal-Mail-Industrial-Action" 
    target="_blank" 
    rel="noopener nofollow">
      Read more
    </a>`,
    type: "warning-banner",
  },
  startDate: new Date("Thu, 22 Dec 2022 00:00:01 UTC"),
  endDate: new Date("Sat, 24 Dec 2022 14:00:00 UTC"),
  activeForBrands: ["medexpress"],
};
